import { TenantTemplateRouterCore } from "@components/tenant/TenantTemplateRouter";
import DefaultSettlementPrint from "./default";

const templates = import.meta.glob<{ default: React.ComponentType<any> }>(
  "/src/pages/user/Settlements/Print/templates/*/index.tsx"
);

type SettlementPrintProps = {
};

export default function SettlementPrint(props: SettlementPrintProps) {
  return (
    <TenantTemplateRouterCore<SettlementPrintProps>
      templates={templates}
      DefaultComponent={DefaultSettlementPrint}
      passProps={props}
    />
  );
}